import React from 'react';

// Shared building blocks of the POS settings screens (PosSettings, DeviceSettingsPanel).

export function StatusBadge({ tone = 'neutral', children }) {
  const styles = {
    positive: 'bg-lime-100 text-lime-800',
    warning: 'bg-amber-100 text-amber-800',
    danger: 'bg-red-100 text-red-700',
    info: 'bg-sky-100 text-sky-700',
    neutral: 'bg-muted text-muted-foreground',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.08em] ${styles[tone] || styles.neutral}`}>
      {children}
    </span>
  );
}

export function SectionHeader({ title, subtitle, action }) {
  return (
    <div className="border-b border-border bg-muted px-5 py-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-foreground">{title}</h2>
          {subtitle ? <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p> : null}
        </div>
        {action || null}
      </div>
    </div>
  );
}

export function DetailCard({ title, subtitle, children, compact = false }) {
  return (
    <section className="border border-border bg-card">
      <div className="border-b border-border px-5 py-4">
        <h3 className="text-xl font-bold text-foreground">{title}</h3>
        {subtitle ? <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p> : null}
      </div>
      <div className={compact ? 'px-5 py-3' : 'px-5 py-4'}>{children}</div>
    </section>
  );
}

export function KeyValueRows({ rows }) {
  return (
    <div className="divide-y divide-slate-100">
      {rows.map((row) => (
        <div key={row.label} className="grid grid-cols-[minmax(0,1fr)_auto] gap-4 py-3">
          <span className="text-sm text-muted-foreground">{row.label}</span>
          <span className="text-right text-sm font-medium text-foreground">{row.value}</span>
        </div>
      ))}
    </div>
  );
}

export function SelectField({ value, options, onChange, disabled = false }) {
  return (
    <select
      value={value || ''}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      className="w-full border border-border bg-card px-3 py-2 text-sm text-muted-foreground outline-none transition-colors focus:border-primary disabled:cursor-not-allowed disabled:bg-muted"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
